import { render, staticRenderFns } from "./CertificateLayout.vue?vue&type=template&id=93937500&"
import script from "./CertificateLayout.vue?vue&type=script&lang=js&"
export * from "./CertificateLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports